/**
 * Layout Component
 * Main layout wrapper with header, footer, cart drawer, and SEO
 */

import { ReactNode, useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from '../cart/CartDrawer';
import { useCartStore } from '~/store/cart-store';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const initializeCart = useCartStore((state) => state.initializeCart);

  // Initialize cart on mount
  useEffect(() => {
    initializeCart();
  }, [initializeCart]);

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" aria-hidden="true" />

      <Header />

      <main className="flex-1">{children}</main>

      <Footer />

      {/* Cart Drawer */}
      <CartDrawer />
    </div>
  );
}
